import { render, staticRenderFns } from "./AssignmentSelector.vue?vue&type=template&id=a2bad194&scoped=true"
import script from "./AssignmentSelector.vue?vue&type=script&lang=js"
export * from "./AssignmentSelector.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSelector.vue?vue&type=style&index=0&id=a2bad194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bad194",
  null
  
)

export default component.exports